import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { IUseEarlyAccess } from '@pro/activity/testerClub/useEarlyAccess';
import { useTrans } from 'base/utils/i18n';
import cn from 'classnames';
import { getActivityReviewPage } from 'mod/review/service';
import Image from '@base/lib/ThemeImage';
import TesterReviewItem from '@app/activity/testerClub/TesterReviewItem';
import { IReviewPage } from 'mod/review/interface';
import { Button } from '@base/lib/Button';
import ThemeEmpty from '@base/lib/ThemeEmpty'

type IProps = {
    earlyAccess: IUseEarlyAccess;
    className?: string;
}

const TesterReviews: React.FC<IProps> = (props) => {
    const { earlyAccess, className } = props
    const [reviewsData, setReviewsData] = useState<IReviewPage>()
    const [loading, setLoading] = useState<boolean>(true)

    const { showLists, wholeList = [] } = earlyAccess

    const { t } = useTrans();

    const getTesterReviews = async (params: {
        page: number;
    }) => {
        try {
            setLoading(true);
            const res = await getActivityReviewPage({
                pageSize: 10,
                reviewType: 'early_access',
                activityIds: wholeList?.map((item) => item.activityGid || ''),
                ...params
            });
            setReviewsData({
                ...res,
                list: [
                    ...(reviewsData?.list || []),
                    ...(res.list || [])
                ]
            })

        } catch (err) {

        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!!wholeList?.length) {
            getTesterReviews({
                page: 1,
            }).then()
        }
    }, [wholeList]);

    return (
        <div
            id={'js-tester-reviews'}
            className={cn(className)}
        >
            <div className={'wrapper'}>
                <h3 className={cn('g-title text-center')}>
                    {t('web_early_access_tester_reviews')}
                </h3>

                {!reviewsData?.list.length
                    ? <ThemeEmpty tip={' '}/>
                    : (<>
                        <div className={styles['list-wrap']}>
                            {reviewsData.list?.map((review, rIndex) => {
                                const targetActivity = [
                                    ...(showLists?.completed || []),
                                    ...(showLists?.onGoing || [])].find((item) => {
                                    return review.activityId === item.activityGid
                                })

                                return (
                                    <div key={rIndex} className={cn(styles['review-item'], 'flex')}>
                                        <div className={styles['left-box']}>
                                            <Image
                                                fit={'cover'}
                                                fixed
                                                src={targetActivity?.images?.[0].url}
                                                width={418}
                                                height={418}
                                            />
                                        </div>

                                        <div className={cn(styles['right-box'], 'flex-1')}>
                                            <TesterReviewItem
                                                review={review}
                                                className={styles['review-item-content']}
                                                imageWidth={132}
                                            />
                                        </div>

                                    </div>
                                )
                            })}
                        </div>

                        {reviewsData.totalPage > reviewsData.page && (
                            <div className={cn(styles['page-warp'], 'text-center')}>
                                <Button
                                    loading={loading}
                                    type={'link'}
                                    onClick={() => {
                                        getTesterReviews({
                                            page: reviewsData.page + 1,
                                        }).then()
                                    }}
                                >
                                    {t('web_common_view_more')} &gt;
                                </Button>
                            </div>
                        )}
                    </>)
                }

            </div>

        </div>
    );
};

export default TesterReviews